module.exports = __webpack_public_path__ + "static/media/Melli.6c4d5900.svg";